import React from "react"
import { Table } from "react-bootstrap"
import _ from "lodash"

import { FieldDisplay } from "@/onboarding/features/product/components/shared/Importer"
import { fieldLabel } from "@/onboarding/features/product/models/fieldLabels"

const SectionDiffTable = ({
  diff,
  currentValues,
}: {
  diff: Record<string, any>
  currentValues: Record<string, any>
}): JSX.Element => (
  <Table size="sm" className="mb-0 import-diff-table">
    <thead>
      <tr>
        <th>Field Name</th>
        <th>Current Tour Values</th>
        <th>Importable Tour Values</th>
      </tr>
    </thead>
    <tbody>
      {_.map(diff, (value, fieldName) => (
        <tr key={fieldName}>
          <td>{fieldLabel(fieldName)}</td>
          <td>
            <FieldDisplay value={currentValues[fieldName]} />
          </td>
          <td>
            <FieldDisplay value={value} />
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
)

export default SectionDiffTable
